import { NavBarBtnModel } from 'common/src/models';
import { ContextMenuItemAction } from 'common/src/models/context-menu.model';

export function getEditOnlyPreviewFooterActions(disabled: boolean = false): NavBarBtnModel[] {
  return [{
    classes: 'btn-white',
    iconName: 'edit',
    isMoreAction: true,
    actions: [{
      actionTitle: 'BUTTON.EDIT',
      actionName: ContextMenuItemAction.EDIT,
      actionIcon: 'edit',
      classes: 'btn-white',
      disabled,
    }],
  }];
}
